import { PUBLIC_ICON_URL } from "./constants";
import type { Category, Toolkit } from "./types";

export const CATEGORIES: Category[] = [
  { id: "all", name: "All Tools" },
  { id: "productivity", name: "Productivity & Docs" },
  { id: "social", name: "Social & Communication" },
  { id: "development", name: "Developer Tools" },
  { id: "entertainment", name: "Entertainment" },
  { id: "search", name: "Search" },
  { id: "payments", name: "Payments & Finance" },
  { id: "sales", name: "Sales" },
  { id: "databases", name: "Databases" },
  { id: "customer-support", name: "Customer Support" },
];

export const TOOLKITS: Toolkit[] = [
  {
    id: "ADPWorkforceNow",
    label: "ADP Workforce Now",
    isBYOC: false,
    isPro: false,
    publicIconUrl: `${PUBLIC_ICON_URL}/adp.svg`,
    docsLink:
      "https://docs.arcade.dev/en/resources/integrations/productivity/adp",
    relativeDocsLink: "/en/resources/integrations/productivity/adp",
    category: "productivity",
    type: "arcade",
    isComingSoon: true,
    isHidden: false,
  },
  {
    id: "Aha",
    label: "Aha",
    isBYOC: false,
    isPro: false,
    publicIconUrl: `${PUBLIC_ICON_URL}/aha.svg`,
    docsLink:
      "https://docs.arcade.dev/en/resources/integrations/productivity/aha",
    relativeDocsLink: "/en/resources/integrations/productivity/aha",
    category: "productivity",
    type: "arcade",
    isComingSoon: true,
    isHidden: false,
  },
  {
    id: "AirtableApi",
    label: "Airtable API",
    isBYOC: false,
    isPro: false,
    publicIconUrl: `${PUBLIC_ICON_URL}/airtable.svg`,
    docsLink:
      "https://docs.arcade.dev/en/resources/integrations/productivity/airtable-api",
    relativeDocsLink: "/en/resources/integrations/productivity/airtable-api",
    category: "productivity",
    type: "arcade_starter",
    isComingSoon: false,
    isHidden: false,
  },
  {
    id: "Amplitude",
    label: "Amplitude",
    isBYOC: false,
    isPro: false,
    publicIconUrl: `${PUBLIC_ICON_URL}/amplitude.svg`,
    docsLink:
      "https://docs.arcade.dev/en/resources/integrations/productivity/amplitude",
    relativeDocsLink: "/en/resources/integrations/productivity/amplitude",
    category: "productivity",
    type: "arcade",
    isComingSoon: true,
    isHidden: false,
  },
  {
    id: "Apollo",
    label: "Apollo",
    isBYOC: false,
    isPro: false,
    publicIconUrl: `${PUBLIC_ICON_URL}/apollo.svg`,
    docsLink: "https://docs.arcade.dev/en/resources/integrations/sales/apollo",
    relativeDocsLink: "/en/resources/integrations/sales/apollo",
    category: "sales",
    type: "arcade",
    isComingSoon: false,
    isHidden: false,
  },
  {
    id: "ArcadeEngineApi",
    label: "Arcade Engine API",
    isBYOC: false,
    isPro: false,
    publicIconUrl: `${PUBLIC_ICON_URL}/arcade.svg`,
    docsLink:
      "https://docs.arcade.dev/en/resources/integrations/development/arcade-engine-api",
    relativeDocsLink:
      "/en/resources/integrations/development/arcade-engine-api",
    category: "development",
    type: "arcade_starter",
    isComingSoon: false,
    isHidden: false,
  },
  {
    id: "Asana",
    label: "Asana",
    isBYOC: false,
    isPro: false,
    publicIconUrl: `${PUBLIC_ICON_URL}/asana.svg`,
    docsLink:
      "https://docs.arcade.dev/en/resources/integrations/productivity/asana",
    relativeDocsLink: "/en/resources/integrations/productivity/asana",
    category: "productivity",
    type: "arcade",
    isComingSoon: false,
    isHidden: false,
  },
  {
    id: "AsanaApi",
    label: "Asana API",
    isBYOC: false,
    isPro: false,
    publicIconUrl: `${PUBLIC_ICON_URL}/asana.svg`,
    docsLink:
      "https://docs.arcade.dev/en/resources/integrations/productivity/asana-api",
    relativeDocsLink: "/en/resources/integrations/productivity/asana-api",
    category: "productivity",
    type: "arcade_starter",
    isComingSoon: false,
    isHidden: false,
  },
  {
    id: "Ashby",
    label: "Ashby",
    isBYOC: true,
    isPro: false,
    publicIconUrl: `${PUBLIC_ICON_URL}/ashby.svg`,
    docsLink:
      "https://docs.arcade.dev/en/resources/integrations/productivity/ashby",
    relativeDocsLink: "/en/resources/integrations/productivity/ashby",
    category: "productivity",
    type: "arcade",
    isComingSoon: false,
    isHidden: false,
  },
  {
    id: "AshbyApi",
    label: "Ashby API",
    isBYOC: false,
    isPro: false,
    publicIconUrl: `${PUBLIC_ICON_URL}/ashby.svg`,
    docsLink:
      "https://docs.arcade.dev/en/resources/integrations/productivity/ashby-api",
    relativeDocsLink: "/en/resources/integrations/productivity/ashby-api",
    category: "productivity",
    type: "arcade_starter",
    isComingSoon: false,
    isHidden: false,
  },
  {
    id: "Attio",
    label: "Attio",
    isBYOC: false,
    isPro: false,
    publicIconUrl: `${PUBLIC_ICON_URL}/attio.svg`,
    docsLink: "https://docs.arcade.dev/en/resources/integrations/sales/attio",
    relativeDocsLink: "/en/resources/integrations/sales/attio",
    category: "sales",
    type: "arcade",
    isComingSoon: false,
    isHidden: false,
  },
  {
    id: "Auth0",
    label: "Auth0",
    isBYOC: false,
    isPro: false,
    publicIconUrl: `${PUBLIC_ICON_URL}/auth0.svg`,
    docsLink:
      "https://docs.arcade.dev/en/resources/integrations/development/auth0",
    relativeDocsLink: "/en/resources/integrations/development/auth0",
    category: "development",
    type: "arcade",
    isComingSoon: true,
    isHidden: false,
  },
  {
    id: "BambooHR",
    label: "BambooHR",
    isBYOC: false,
    isPro: false,
    publicIconUrl: `${PUBLIC_ICON_URL}/bamboohr.svg`,
    docsLink:
      "https://docs.arcade.dev/en/resources/integrations/productivity/bamboohr",
    relativeDocsLink: "/en/resources/integrations/productivity/bamboohr",
    category: "productivity",
    type: "arcade",
    isComingSoon: true,
    isHidden: false,
  },
  {
    id: "Basecamp",
    label: "Basecamp",
    isBYOC: false,
    isPro: false,
    publicIconUrl: `${PUBLIC_ICON_URL}/basecamp.svg`,
    docsLink:
      "https://docs.arcade.dev/en/resources/integrations/productivity/basecamp",
    relativeDocsLink: "/en/resources/integrations/productivity/basecamp",
    category: "productivity",
    type: "arcade",
    isComingSoon: true,
    isHidden: false,
  },
  {
    id: "BillCom",
    label: "Bill.com",
    isBYOC: false,
    isPro: false,
    publicIconUrl: `${PUBLIC_ICON_URL}/bill.svg`,
    docsLink:
      "https://docs.arcade.dev/en/resources/integrations/productivity/bill",
    relativeDocsLink: "/en/resources/integrations/productivity/bill",
    category: "productivity",
    type: "arcade",
    isComingSoon: true,
    isHidden: false,
  },
  {
    id: "Bitbucket",
    label: "Bitbucket",
    isBYOC: false,
    isPro: false,
    publicIconUrl: `${PUBLIC_ICON_URL}/bitbucket.svg`,
    docsLink:
      "https://docs.arcade.dev/en/resources/integrations/development/bitbucket",
    relativeDocsLink: "/en/resources/integrations/development/bitbucket",
    category: "development",
    type: "arcade",
    isComingSoon: true,
    isHidden: false,
  },
  {
    id: "Bluesky",
    label: "Bluesky",
    isBYOC: false,
    isPro: false,
    publicIconUrl: `${PUBLIC_ICON_URL}/bluesky.svg`,
    docsLink:
      "https://docs.arcade.dev/en/resources/integrations/social-communication/bluesky",
    relativeDocsLink: "/en/resources/integrations/social-communication/bluesky",
    category: "social",
    type: "arcade",
    isComingSoon: true,
    isHidden: false,
  },
  {
    id: "BoxApi",
    label: "Box API",
    isBYOC: false,
    isPro: false,
    publicIconUrl: `${PUBLIC_ICON_URL}/box.svg`,
    docsLink:
      "https://docs.arcade.dev/en/resources/integrations/productivity/box-api",
    relativeDocsLink: "/en/resources/integrations/productivity/box-api",
    category: "productivity",
    type: "arcade_starter",
    isComingSoon: false,
    isHidden: false,
  },
  {
    id: "Brightdata",
    label: "Bright Data",
    isBYOC: true,
    isPro: false,
    publicIconUrl: `${PUBLIC_ICON_URL}/brightdata.svg`,
    docsLink:
      "https://docs.arcade.dev/en/resources/integrations/development/brightdata",
    relativeDocsLink: "/en/resources/integrations/development/brightdata",
    category: "development",
    type: "community",
    isComingSoon: false,
    isHidden: false,
  },
  {
    id: "Braze",
    label: "Braze",
    isBYOC: false,
    isPro: false,
    publicIconUrl: `${PUBLIC_ICON_URL}/braze.svg`,
    docsLink:
      "https://docs.arcade.dev/en/resources/integrations/productivity/braze",
    relativeDocsLink: "/en/resources/integrations/productivity/braze",
    category: "productivity",
    type: "arcade",
    isComingSoon: true,
    isHidden: false,
  },
  {
    id: "Brex",
    label: "Brex",
    isBYOC: false,
    isPro: false,
    publicIconUrl: `${PUBLIC_ICON_URL}/brex.svg`,
    docsLink:
      "https://docs.arcade.dev/en/resources/integrations/productivity/brex",
    relativeDocsLink: "/en/resources/integrations/productivity/brex",
    category: "productivity",
    type: "arcade",
    isComingSoon: true,
    isHidden: false,
  },
  {
    id: "Buffer",
    label: "Buffer",
    isBYOC: false,
    isPro: false,
    publicIconUrl: `${PUBLIC_ICON_URL}/buffer.svg`,
    docsLink:
      "https://docs.arcade.dev/en/resources/integrations/social-communication/buffer",
    relativeDocsLink: "/en/resources/integrations/social-communication/buffer",
    category: "social",
    type: "arcade",
    isComingSoon: true,
    isHidden: false,
  },
  {
    id: "CalendlyApi",
    label: "Calendly API",
    isBYOC: false,
    isPro: false,
    publicIconUrl: `${PUBLIC_ICON_URL}/calendly.svg`,
    docsLink:
      "https://docs.arcade.dev/en/resources/integrations/productivity/calendly-api",
    relativeDocsLink: "/en/resources/integrations/productivity/calendly-api",
    category: "productivity",
    type: "arcade_starter",
    isComingSoon: false,
    isHidden: false,
  },
  {
    id: "Clickhouse",
    label: "Clickhouse",
    isBYOC: false,
    isPro: false,
    publicIconUrl: `${PUBLIC_ICON_URL}/clickhouse.svg`,
    docsLink:
      "https://docs.arcade.dev/en/resources/integrations/databases/clickhouse",
    relativeDocsLink: "/en/resources/integrations/databases/clickhouse",
    category: "databases",
    type: "community",
    isComingSoon: false,
    isHidden: false,
  },
  {
    id: "ClickUp",
    label: "ClickUp",
    isBYOC: false,
    isPro: false,
    publicIconUrl: `${PUBLIC_ICON_URL}/clickup.svg`,
    docsLink:
      "https://docs.arcade.dev/en/resources/integrations/productivity/clickup",
    relativeDocsLink: "/en/resources/integrations/productivity/clickup",
    category: "productivity",
    type: "arcade",
    isComingSoon: false,
    isHidden: false,
  },
  {
    id: "ClickUpApi",
    label: "ClickUp API",
    isBYOC: false,
    isPro: false,
    publicIconUrl: `${PUBLIC_ICON_URL}/clickup.svg`,
    docsLink:
      "https://docs.arcade.dev/en/resources/integrations/productivity/clickup-api",
    relativeDocsLink: "/en/resources/integrations/productivity/clickup-api",
    category: "productivity",
    type: "arcade_starter",
    isComingSoon: false,
    isHidden: false,
  },
  {
    id: "CloseIO",
    label: "Close.io",
    isBYOC: false,
    isPro: false,
    publicIconUrl: `${PUBLIC_ICON_URL}/closeio.svg`,
    docsLink:
      "https://docs.arcade.dev/en/resources/integrations/productivity/closeio",
    relativeDocsLink: "/en/resources/integrations/productivity/closeio",
    category: "productivity",
    type: "community",
    isComingSoon: false,
    isHidden: false,
  },
  {
    id: "Codesandbox",
    label: "Codesandbox",
    isBYOC: false,
    isPro: false,
    publicIconUrl: `${PUBLIC_ICON_URL}/codesandbox.svg`,
    docsLink:
      "https://docs.arcade.dev/en/resources/integrations/development/codesandbox",
    relativeDocsLink: "/en/resources/integrations/development/codesandbox",
    category: "development",
    type: "arcade",
    isComingSoon: true,
    isHidden: true,
  },
  {
    id: "Coinbase",
    label: "Coinbase",
    isBYOC: false,
    isPro: false,
    publicIconUrl: `${PUBLIC_ICON_URL}/coinbase.svg`,
    docsLink:
      "https://docs.arcade.dev/en/resources/integrations/productivity/coinbase",
    relativeDocsLink: "/en/resources/integrations/productivity/coinbase",
    category: "productivity",
    type: "arcade",
    isComingSoon: true,
    isHidden: false,
  },
  {
    id: "Confluence",
    label: "Confluence",
    isBYOC: false,
    isPro: false,
    publicIconUrl: `${PUBLIC_ICON_URL}/confluence.svg`,
    docsLink:
      "https://docs.arcade.dev/en/resources/integrations/productivity/confluence",
    relativeDocsLink: "/en/resources/integrations/productivity/confluence",
    category: "productivity",
    type: "arcade",
    isComingSoon: false,
    isHidden: false,
  },
  {
    id: "CursorAgents",
    label: "Cursor Agents",
    isBYOC: false,
    isPro: false,
    publicIconUrl: `${PUBLIC_ICON_URL}/cursor.svg`,
    docsLink:
      "https://docs.arcade.dev/en/resources/integrations/development/cursor-agents",
    relativeDocsLink: "/en/resources/integrations/development/cursor-agents",
    category: "development",
    type: "arcade",
    isComingSoon: false,
    isHidden: false,
  },
  {
    id: "CursorAgentsApi",
    label: "Cursor Agents API",
    isBYOC: false,
    isPro: false,
    publicIconUrl: `${PUBLIC_ICON_URL}/cursor.svg`,
    docsLink:
      "https://docs.arcade.dev/en/resources/integrations/development/cursor-agents-api",
    relativeDocsLink:
      "/en/resources/integrations/development/cursor-agents-api",
    category: "development",
    type: "arcade_starter",
    isComingSoon: false,
    isHidden: false,
  },
  {
    id: "Customerio",
    label: "Customer.io",
    isBYOC: false,
    isPro: false,
    publicIconUrl: `${PUBLIC_ICON_URL}/customerio.svg`,
    docsLink:
      "https://docs.arcade.dev/en/resources/integrations/customer-support/customerio",
    relativeDocsLink: "/en/resources/integrations/customer-support/customerio",
    category: "customer-support",
    type: "arcade",
    isComingSoon: false,
    isHidden: false,
  },
  {
    id: "CustomerioApi",
    label: "Customer.io API",
    isBYOC: false,
    isPro: false,
    publicIconUrl: `${PUBLIC_ICON_URL}/customerio.svg`,
    docsLink:
      "https://docs.arcade.dev/en/resources/integrations/customer-support/customerio-api",
    relativeDocsLink:
      "/en/resources/integrations/customer-support/customerio-api",
    category: "customer-support",
    type: "arcade_starter",
    isComingSoon: false,
    isHidden: false,
  },
  {
    id: "CustomerioPipelinesApi",
    label: "Customer.io Pipelines API",
    isBYOC: false,
    isPro: false,
    publicIconUrl: `${PUBLIC_ICON_URL}/customerio.svg`,
    docsLink:
      "https://docs.arcade.dev/en/resources/integrations/customer-support/customerio-pipelines-api",
    relativeDocsLink:
      "/en/resources/integrations/customer-support/customerio-pipelines-api",
    category: "customer-support",
    type: "arcade_starter",
    isComingSoon: false,
    isHidden: false,
  },
  {
    id: "CustomerioTrackApi",
    label: "Customer.io Track API",
    isBYOC: false,
    isPro: false,
    publicIconUrl: `${PUBLIC_ICON_URL}/customerio.svg`,
    docsLink:
      "https://docs.arcade.dev/en/resources/integrations/customer-support/customerio-track-api",
    relativeDocsLink:
      "/en/resources/integrations/customer-support/customerio-track-api",
    category: "customer-support",
    type: "arcade_starter",
    isComingSoon: false,
    isHidden: false,
  },
  {
    id: "Datadog",
    label: "Datadog",
    isBYOC: false,
    isPro: false,
    publicIconUrl: `${PUBLIC_ICON_URL}/datadog.svg`,
    docsLink:
      "https://docs.arcade.dev/en/resources/integrations/development/datadog",
    relativeDocsLink: "/en/resources/integrations/development/datadog",
    category: "development",
    type: "arcade",
    isComingSoon: false,
    isHidden: false,
  },
  {
    id: "DatadogApi",
    label: "Datadog API",
    isBYOC: false,
    isPro: false,
    publicIconUrl: `${PUBLIC_ICON_URL}/datadog.svg`,
    docsLink:
      "https://docs.arcade.dev/en/resources/integrations/development/datadog-api",
    relativeDocsLink: "/en/resources/integrations/development/datadog-api",
    category: "development",
    type: "arcade_starter",
    isComingSoon: false,
    isHidden: false,
  },
  {
    id: "Daytona",
    label: "Daytona",
    isBYOC: false,
    isPro: false,
    publicIconUrl: `${PUBLIC_ICON_URL}/daytona.svg`,
    docsLink:
      "https://docs.arcade.dev/en/resources/integrations/development/daytona",
    relativeDocsLink: "/en/resources/integrations/development/daytona",
    category: "development",
    type: "arcade",
    isComingSoon: false,
    isHidden: false,
  },
  {
    id: "DigitalOcean",
    label: "DigitalOcean",
    isBYOC: false,
    isPro: false,
    publicIconUrl: `${PUBLIC_ICON_URL}/digital-ocean.svg`,
    docsLink:
      "https://docs.arcade.dev/en/resources/integrations/development/digitalocean",
    relativeDocsLink: "/en/resources/integrations/development/digitalocean",
    category: "development",
    type: "arcade",
    isComingSoon: true,
    isHidden: false,
  },
  {
    id: "Discord",
    label: "Discord",
    isBYOC: false,
    isPro: false,
    publicIconUrl: `${PUBLIC_ICON_URL}/discord.svg`,
    docsLink:
      "https://docs.arcade.dev/en/resources/integrations/social-communication/discord",
    relativeDocsLink: "/en/resources/integrations/social-communication/discord",
    category: "social",
    type: "auth",
    isComingSoon: false,
    isHidden: false,
  },
  {
    id: "DiscordBot",
    label: "Discord Bot",
    isBYOC: false,
    isPro: false,
    publicIconUrl: `${PUBLIC_ICON_URL}/discord.svg`,
    docsLink:
      "https://docs.arcade.dev/en/resources/integrations/social-communication/discord-bot",
    relativeDocsLink:
      "/en/resources/integrations/social-communication/discord-bot",
    category: "social",
    type: "arcade",
    isComingSoon: false,
    isHidden: false,
  },
  {
    id: "Dropbox",
    label: "Dropbox",
    isBYOC: false,
    isPro: false,
    publicIconUrl: `${PUBLIC_ICON_URL}/dropbox.svg`,
    docsLink:
      "https://docs.arcade.dev/en/resources/integrations/productivity/dropbox",
    relativeDocsLink: "/en/resources/integrations/productivity/dropbox",
    category: "productivity",
    type: "arcade",
    isComingSoon: false,
    isHidden: false,
  },
  {
    id: "E2b",
    label: "E2B",
    isBYOC: true,
    isPro: true,
    publicIconUrl: `${PUBLIC_ICON_URL}/e2b.svg`,
    docsLink:
      "https://docs.arcade.dev/en/resources/integrations/development/e2b",
    relativeDocsLink: "/en/resources/integrations/development/e2b",
    category: "development",
    type: "arcade",
    isComingSoon: false,
    isHidden: false,
  },
  {
    id: "EBay",
    label: "eBay",
    isBYOC: false,
    isPro: false,
    publicIconUrl: `${PUBLIC_ICON_URL}/ebay.svg`,
    docsLink:
      "https://docs.arcade.dev/en/resources/integrations/productivity/ebay",
    relativeDocsLink: "/en/resources/integrations/productivity/ebay",
    category: "productivity",
    type: "arcade",
    isComingSoon: true,
    isHidden: false,
  },
  {
    id: "Evernote",
    label: "Evernote",
    isBYOC: false,
    isPro: false,
    publicIconUrl: `${PUBLIC_ICON_URL}/evernote.svg`,
    docsLink:
      "https://docs.arcade.dev/en/resources/integrations/productivity/evernote",
    relativeDocsLink: "/en/resources/integrations/productivity/evernote",
    category: "productivity",
    type: "arcade",
    isComingSoon: true,
    isHidden: false,
  },
  {
    id: "ExaApi",
    label: "Exa API",
    isBYOC: false,
    isPro: false,
    publicIconUrl: `${PUBLIC_ICON_URL}/exa.svg`,
    docsLink:
      "https://docs.arcade.dev/en/resources/integrations/search/exa-api",
    relativeDocsLink: "/en/resources/integrations/search/exa-api",
    category: "search",
    type: "arcade_starter",
    isComingSoon: false,
    isHidden: false,
  },
  {
    id: "Factorial",
    label: "Factorial",
    isBYOC: false,
    isPro: false,
    publicIconUrl: `${PUBLIC_ICON_URL}/factorial.svg`,
    docsLink:
      "https://docs.arcade.dev/en/resources/integrations/productivity/factorial",
    relativeDocsLink: "/en/resources/integrations/productivity/factorial",
    category: "productivity",
    type: "arcade",
    isComingSoon: true,
    isHidden: false,
  },
  {
    id: "Figma",
    label: "Figma",
    isBYOC: false,
    isPro: false,
    publicIconUrl: `${PUBLIC_ICON_URL}/figma.svg`,
    docsLink:
      "https://docs.arcade.dev/en/resources/integrations/productivity/figma",
    relativeDocsLink: "/en/resources/integrations/productivity/figma",
    category: "productivity",
    type: "arcade",
    isComingSoon: false,
    isHidden: false,
  },
  {
    id: "FigmaApi",
    label: "Figma API",
    isBYOC: false,
    isPro: false,
    publicIconUrl: `${PUBLIC_ICON_URL}/figma.svg`,
    docsLink:
      "https://docs.arcade.dev/en/resources/integrations/productivity/figma-api",
    relativeDocsLink: "/en/resources/integrations/productivity/figma-api",
    category: "productivity",
    type: "arcade_starter",
    isComingSoon: false,
    isHidden: false,
  },
  {
    id: "Firecrawl",
    label: "Firecrawl",
    isBYOC: true,
    isPro: true,
    publicIconUrl: `${PUBLIC_ICON_URL}/firecrawl.svg`,
    docsLink:
      "https://docs.arcade.dev/en/resources/integrations/development/firecrawl",
    relativeDocsLink: "/en/resources/integrations/development/firecrawl",
    category: "development",
    type: "arcade",
    isComingSoon: false,
    isHidden: false,
  },
  {
    id: "Fireflies",
    label: "Fireflies",
    isBYOC: true,
    isPro: false,
    publicIconUrl: `${PUBLIC_ICON_URL}/fireflies.svg`,
    docsLink:
      "https://docs.arcade.dev/en/resources/integrations/productivity/fireflies",
    relativeDocsLink: "/en/resources/integrations/productivity/fireflies",
    category: "productivity",
    type: "arcade",
    isComingSoon: false,
    isHidden: false,
  },
  {
    id: "FlyIo",
    label: "Fly.io",
    isBYOC: true,
    isPro: false,
    publicIconUrl: `${PUBLIC_ICON_URL}/fly-io.svg`,
    docsLink:
      "https://docs.arcade.dev/en/resources/integrations/development/fly-io",
    relativeDocsLink: "/en/resources/integrations/development/fly-io",
    category: "development",
    type: "arcade",
    isComingSoon: false,
    isHidden: false,
  },
  {
    id: "Forkable",
    label: "Forkable",
    isBYOC: false,
    isPro: false,
    publicIconUrl: `${PUBLIC_ICON_URL}/forkable.svg`,
    docsLink:
      "https://docs.arcade.dev/en/resources/integrations/productivity/forkable",
    relativeDocsLink: "/en/resources/integrations/productivity/forkable",
    category: "productivity",
    type: "arcade",
    isComingSoon: false,
    isHidden: false,
  },
  {
    id: "Freshdesk",
    label: "Freshdesk",
    isBYOC: false,
    isPro: false,
    publicIconUrl: `${PUBLIC_ICON_URL}/freshdesk.svg`,
    docsLink:
      "https://docs.arcade.dev/en/resources/integrations/customer-support/freshdesk",
    relativeDocsLink: "/en/resources/integrations/customer-support/freshdesk",
    category: "customer-support",
    type: "arcade",
    isComingSoon: false,
    isHidden: false,
  },
  {
    id: "FreshserviceApi",
    label: "Freshservice API",
    isBYOC: false,
    isPro: false,
    publicIconUrl: `${PUBLIC_ICON_URL}/freshservice.svg`,
    docsLink:
      "https://docs.arcade.dev/en/resources/integrations/customer-support/freshservice-api",
    relativeDocsLink:
      "/en/resources/integrations/customer-support/freshservice-api",
    category: "customer-support",
    type: "arcade_starter",
    isComingSoon: false,
    isHidden: false,
  },
  {
    id: "Github",
    label: "GitHub",
    isBYOC: false,
    isPro: false,
    publicIconUrl: `${PUBLIC_ICON_URL}/github.svg`,
    docsLink:
      "https://docs.arcade.dev/en/resources/integrations/development/github",
    relativeDocsLink: "/en/resources/integrations/development/github",
    category: "development",
    type: "arcade",
    isComingSoon: false,
    isHidden: false,
  },
  {
    id: "GithubApi",
    label: "GitHub API",
    isBYOC: false,
    isPro: false,
    publicIconUrl: `${PUBLIC_ICON_URL}/github.svg`,
    docsLink:
      "https://docs.arcade.dev/en/resources/integrations/development/github-api",
    relativeDocsLink: "/en/resources/integrations/development/github-api",
    category: "development",
    type: "arcade_starter",
    isComingSoon: false,
    isHidden: false,
  },
  {
    id: "GitLab",
    label: "GitLab",
    isBYOC: false,
    isPro: false,
    publicIconUrl: `${PUBLIC_ICON_URL}/gitlab.svg`,
    docsLink:
      "https://docs.arcade.dev/en/resources/integrations/development/gitlab",
    relativeDocsLink: "/en/resources/integrations/development/gitlab",
    category: "development",
    type: "arcade",
    isComingSoon: true,
    isHidden: false,
  },
  {
    id: "Glean",
    label: "Glean",
    isBYOC: true,
    isPro: false,
    publicIconUrl: `${PUBLIC_ICON_URL}/glean.svg`,
    docsLink: "https://docs.arcade.dev/en/resources/integrations/search/glean",
    relativeDocsLink: "/en/resources/integrations/search/glean",
    category: "search",
    type: "arcade",
    isComingSoon: false,
    isHidden: false,
  },
  {
    id: "Gmail",
    label: "Gmail",
    isBYOC: false,
    isPro: false,
    publicIconUrl: `${PUBLIC_ICON_URL}/gmail.svg`,
    docsLink:
      "https://docs.arcade.dev/en/resources/integrations/productivity/gmail",
    relativeDocsLink: "/en/resources/integrations/productivity/gmail",
    category: "productivity",
    type: "arcade",
    isComingSoon: false,
    isHidden: false,
  },
  {
    id: "GoogleCalendar",
    label: "Google Calendar",
    isBYOC: false,
    isPro: false,
    publicIconUrl: `${PUBLIC_ICON_URL}/google-calendar.svg`,
    docsLink:
      "https://docs.arcade.dev/en/resources/integrations/productivity/google-calendar",
    relativeDocsLink: "/en/resources/integrations/productivity/google-calendar",
    category: "productivity",
    type: "arcade",
    isComingSoon: false,
    isHidden: false,
  },
  {
    id: "GoogleContacts",
    label: "Google Contacts",
    isBYOC: false,
    isPro: false,
    publicIconUrl: `${PUBLIC_ICON_URL}/google-contacts.svg`,
    docsLink:
      "https://docs.arcade.dev/en/resources/integrations/productivity/google-contacts",
    relativeDocsLink: "/en/resources/integrations/productivity/google-contacts",
    category: "productivity",
    type: "arcade",
    isComingSoon: false,
    isHidden: false,
  },
  {
    id: "GoogleDocs",
    label: "Google Docs",
    isBYOC: false,
    isPro: false,
    publicIconUrl: `${PUBLIC_ICON_URL}/google-docs.svg`,
    docsLink:
      "https://docs.arcade.dev/en/resources/integrations/productivity/google-docs",
    relativeDocsLink: "/en/resources/integrations/productivity/google-docs",
    category: "productivity",
    type: "arcade",
    isComingSoon: false,
    isHidden: false,
  },
  {
    id: "GoogleDrive",
    label: "Google Drive",
    isBYOC: false,
    isPro: false,
    publicIconUrl: `${PUBLIC_ICON_URL}/google-drive.svg`,
    docsLink:
      "https://docs.arcade.dev/en/resources/integrations/productivity/google-drive",
    relativeDocsLink: "/en/resources/integrations/productivity/google-drive",
    category: "productivity",
    type: "arcade",
    isComingSoon: false,
    isHidden: false,
  },
  {
    id: "GoogleForms",
    label: "Google Forms",
    isBYOC: false,
    isPro: false,
    publicIconUrl: `${PUBLIC_ICON_URL}/google-forms.svg`,
    docsLink:
      "https://docs.arcade.dev/en/resources/integrations/productivity/google-forms",
    relativeDocsLink: "/en/resources/integrations/productivity/google-forms",
    category: "productivity",
    type: "arcade",
    isComingSoon: false,
    isHidden: false,
  },
  {
    id: "GoogleFinance",
    label: "Google Finance",
    isBYOC: true,
    isPro: true,
    publicIconUrl: `${PUBLIC_ICON_URL}/google-finance.svg`,
    docsLink:
      "https://docs.arcade.dev/en/resources/integrations/search/google_finance",
    relativeDocsLink: "/en/resources/integrations/search/google_finance",
    category: "search",
    type: "arcade",
    isComingSoon: false,
    isHidden: false,
  },
  {
    id: "GoogleFlights",
    label: "Google Flights",
    isBYOC: true,
    isPro: true,
    publicIconUrl: `${PUBLIC_ICON_URL}/google-flights.svg`,
    docsLink:
      "https://docs.arcade.dev/en/resources/integrations/search/google_flights",
    relativeDocsLink: "/en/resources/integrations/search/google_flights",
    category: "search",
    type: "arcade",
    isComingSoon: false,
    isHidden: false,
  },
  {
    id: "GoogleHotels",
    label: "Google Hotels",
    isBYOC: true,
    isPro: true,
    publicIconUrl: `${PUBLIC_ICON_URL}/google-hotels.svg`,
    docsLink:
      "https://docs.arcade.dev/en/resources/integrations/search/google_hotels",
    relativeDocsLink: "/en/resources/integrations/search/google_hotels",
    category: "search",
    type: "arcade",
    isComingSoon: false,
    isHidden: false,
  },
  {
    id: "GoogleJobs",
    label: "Google Jobs",
    isBYOC: true,
    isPro: true,
    publicIconUrl: `${PUBLIC_ICON_URL}/google-jobs.svg`,
    docsLink:
      "https://docs.arcade.dev/en/resources/integrations/search/google_jobs",
    relativeDocsLink: "/en/resources/integrations/search/google_jobs",
    category: "search",
    type: "arcade",
    isComingSoon: false,
    isHidden: false,
  },
  {
    id: "GoogleMaps",
    label: "Google Maps",
    isBYOC: true,
    isPro: true,
    publicIconUrl: `${PUBLIC_ICON_URL}/google-maps.svg`,
    docsLink:
      "https://docs.arcade.dev/en/resources/integrations/search/google_maps",
    relativeDocsLink: "/en/resources/integrations/search/google_maps",
    category: "search",
    type: "arcade",
    isComingSoon: false,
    isHidden: false,
  },
  {
    id: "GoogleNews",
    label: "Google News",
    isBYOC: true,
    isPro: true,
    publicIconUrl: `${PUBLIC_ICON_URL}/google-news.svg`,
    docsLink:
      "https://docs.arcade.dev/en/resources/integrations/search/google_news",
    relativeDocsLink: "/en/resources/integrations/search/google_news",
    category: "search",
    type: "arcade",
    isComingSoon: false,
    isHidden: false,
  },
  {
    id: "GoogleSearch",
    label: "Google Search",
    isBYOC: true,
    isPro: true,
    publicIconUrl: `${PUBLIC_ICON_URL}/google-search.svg`,
    docsLink:
      "https://docs.arcade.dev/en/resources/integrations/search/google_search",
    relativeDocsLink: "/en/resources/integrations/search/google_search",
    category: "search",
    type: "arcade",
    isComingSoon: false,
    isHidden: false,
  },
  {
    id: "GoogleSheets",
    label: "Google Sheets",
    isBYOC: false,
    isPro: false,
    publicIconUrl: `${PUBLIC_ICON_URL}/google-sheets.svg`,
    docsLink:
      "https://docs.arcade.dev/en/resources/integrations/productivity/google-sheets",
    relativeDocsLink: "/en/resources/integrations/productivity/google-sheets",
    category: "productivity",
    type: "arcade",
    isComingSoon: false,
    isHidden: false,
  },
  {
    id: "GoogleShopping",
    label: "Google Shopping",
    isBYOC: true,
    isPro: true,
    publicIconUrl: `${PUBLIC_ICON_URL}/google-shopping.svg`,
    docsLink:
      "https://docs.arcade.dev/en/resources/integrations/search/google_shopping",
    relativeDocsLink: "/en/resources/integrations/search/google_shopping",
    category: "search",
    type: "arcade",
    isComingSoon: false,
    isHidden: false,
  },
  {
    id: "GoogleSlides",
    label: "Google Slides",
    isBYOC: false,
    isPro: false,
    publicIconUrl: `${PUBLIC_ICON_URL}/google-slides.svg`,
    docsLink:
      "https://docs.arcade.dev/en/resources/integrations/productivity/google-slides",
    relativeDocsLink: "/en/resources/integrations/productivity/google-slides",
    category: "productivity",
    type: "arcade",
    isComingSoon: false,
    isHidden: false,
  },
  {
    id: "Granola",
    label: "Granola",
    isBYOC: true,
    isPro: false,
    publicIconUrl: `${PUBLIC_ICON_URL}/granola.svg`,
    docsLink:
      "https://docs.arcade.dev/en/resources/integrations/productivity/granola",
    relativeDocsLink: "/en/resources/integrations/productivity/granola",
    category: "productivity",
    type: "arcade",
    isComingSoon: false,
    isHidden: false,
  },
  {
    id: "Heroku",
    label: "Heroku",
    isBYOC: false,
    isPro: false,
    publicIconUrl: `${PUBLIC_ICON_URL}/heroku.svg`,
    docsLink:
      "https://docs.arcade.dev/en/resources/integrations/development/heroku",
    relativeDocsLink: "/en/resources/integrations/development/heroku",
    category: "development",
    type: "arcade",
    isComingSoon: true,
    isHidden: false,
  },
  {
    id: "Hootsuite",
    label: "Hootsuite",
    isBYOC: false,
    isPro: false,
    publicIconUrl: `${PUBLIC_ICON_URL}/hootsuite.svg`,
    docsLink:
      "https://docs.arcade.dev/en/resources/integrations/social-communication/hootsuite",
    relativeDocsLink:
      "/en/resources/integrations/social-communication/hootsuite",
    category: "social",
    type: "arcade",
    isComingSoon: true,
    isHidden: false,
  },
  {
    id: "Hubspot",
    label: "HubSpot",
    isBYOC: false,
    isPro: false,
    publicIconUrl: `${PUBLIC_ICON_URL}/hubspot.svg`,
    docsLink: "https://docs.arcade.dev/en/resources/integrations/sales/hubspot",
    relativeDocsLink: "/en/resources/integrations/sales/hubspot",
    category: "sales",
    type: "arcade",
    isComingSoon: false,
    isHidden: false,
  },
  {
    id: "HubspotAutomationApi",
    label: "HubSpot Automation API",
    isBYOC: false,
    isPro: false,
    publicIconUrl: `${PUBLIC_ICON_URL}/hubspot.svg`,
    docsLink:
      "https://docs.arcade.dev/en/resources/integrations/sales/hubspot-automation-api",
    relativeDocsLink: "/en/resources/integrations/sales/hubspot-automation-api",
    category: "sales",
    type: "arcade_starter",
    isComingSoon: false,
    isHidden: false,
  },
  {
    id: "HubspotCmsApi",
    label: "HubSpot CMS API",
    isBYOC: false,
    isPro: false,
    publicIconUrl: `${PUBLIC_ICON_URL}/hubspot.svg`,
    docsLink:
      "https://docs.arcade.dev/en/resources/integrations/sales/hubspot-cms-api",
    relativeDocsLink: "/en/resources/integrations/sales/hubspot-cms-api",
    category: "sales",
    type: "arcade_starter",
    isComingSoon: false,
    isHidden: false,
  },
  {
    id: "HubspotConversationsApi",
    label: "HubSpot Conversations API",
    isBYOC: false,
    isPro: false,
    publicIconUrl: `${PUBLIC_ICON_URL}/hubspot.svg`,
    docsLink:
      "https://docs.arcade.dev/en/resources/integrations/sales/hubspot-conversations-api",
    relativeDocsLink:
      "/en/resources/integrations/sales/hubspot-conversations-api",
    category: "sales",
    type: "arcade_starter",
    isComingSoon: false,
    isHidden: false,
  },
  {
    id: "HubspotCrmApi",
    label: "HubSpot CRM API",
    isBYOC: false,
    isPro: false,
    publicIconUrl: `${PUBLIC_ICON_URL}/hubspot.svg`,
    docsLink:
      "https://docs.arcade.dev/en/resources/integrations/sales/hubspot-crm-api",
    relativeDocsLink: "/en/resources/integrations/sales/hubspot-crm-api",
    category: "sales",
    type: "arcade_starter",
    isComingSoon: false,
    isHidden: false,
  },
  {
    id: "HubspotEventsApi",
    label: "HubSpot Events API",
    isBYOC: false,
    isPro: false,
    publicIconUrl: `${PUBLIC_ICON_URL}/hubspot.svg`,
    docsLink:
      "https://docs.arcade.dev/en/resources/integrations/sales/hubspot-events-api",
    relativeDocsLink: "/en/resources/integrations/sales/hubspot-events-api",
    category: "sales",
    type: "arcade_starter",
    isComingSoon: false,
    isHidden: false,
  },
  {
    id: "HubspotMarketingApi",
    label: "HubSpot Marketing API",
    isBYOC: false,
    isPro: false,
    publicIconUrl: `${PUBLIC_ICON_URL}/hubspot.svg`,
    docsLink:
      "https://docs.arcade.dev/en/resources/integrations/sales/hubspot-marketing-api",
    relativeDocsLink: "/en/resources/integrations/sales/hubspot-marketing-api",
    category: "sales",
    type: "arcade_starter",
    isComingSoon: false,
    isHidden: false,
  },
  {
    id: "HubspotMeetingsApi",
    label: "HubSpot Meetings API",
    isBYOC: false,
    isPro: false,
    publicIconUrl: `${PUBLIC_ICON_URL}/hubspot.svg`,
    docsLink:
      "https://docs.arcade.dev/en/resources/integrations/sales/hubspot-meetings-api",
    relativeDocsLink: "/en/resources/integrations/sales/hubspot-meetings-api",
    category: "sales",
    type: "arcade_starter",
    isComingSoon: false,
    isHidden: false,
  },
  {
    id: "HubspotUsersApi",
    label: "HubSpot Users API",
    isBYOC: false,
    isPro: false,
    publicIconUrl: `${PUBLIC_ICON_URL}/hubspot.svg`,
    docsLink:
      "https://docs.arcade.dev/en/resources/integrations/sales/hubspot-users-api",
    relativeDocsLink: "/en/resources/integrations/sales/hubspot-users-api",
    category: "sales",
    type: "arcade_starter",
    isComingSoon: false,
    isHidden: false,
  },
  {
    id: "Imgflip",
    label: "Imgflip",
    isBYOC: true,
    isPro: true,
    publicIconUrl: `${PUBLIC_ICON_URL}/imgflip.svg`,
    docsLink:
      "https://docs.arcade.dev/en/resources/integrations/entertainment/imgflip",
    relativeDocsLink: "/en/resources/integrations/entertainment/imgflip",
    category: "entertainment",
    type: "arcade",
    isComingSoon: false,
    isHidden: false,
  },
  {
    id: "Insightly",
    label: "Insightly",
    isBYOC: false,
    isPro: false,
    publicIconUrl: `${PUBLIC_ICON_URL}/insightly.svg`,
    docsLink:
      "https://docs.arcade.dev/en/resources/integrations/sales/insightly",
    relativeDocsLink: "/en/resources/integrations/sales/insightly",
    category: "sales",
    type: "arcade",
    isComingSoon: false,
    isHidden: false,
  },
  {
    id: "IntercomApi",
    label: "Intercom API",
    isBYOC: false,
    isPro: false,
    publicIconUrl: `${PUBLIC_ICON_URL}/intercom.svg`,
    docsLink:
      "https://docs.arcade.dev/en/resources/integrations/customer-support/intercom-api",
    relativeDocsLink:
      "/en/resources/integrations/customer-support/intercom-api",
    category: "customer-support",
    type: "arcade_starter",
    isComingSoon: false,
    isHidden: false,
  },
  {
    id: "Jira",
    label: "Jira",
    isBYOC: false,
    isPro: false,
    publicIconUrl: `${PUBLIC_ICON_URL}/jira.svg`,
    docsLink:
      "https://docs.arcade.dev/en/resources/integrations/productivity/jira",
    relativeDocsLink: "/en/resources/integrations/productivity/jira",
    category: "productivity",
    type: "arcade",
    isComingSoon: false,
    isHidden: false,
  },
  {
    id: "Linear",
    label: "Linear",
    isBYOC: false,
    isPro: false,
    publicIconUrl: `${PUBLIC_ICON_URL}/linear.svg`,
    docsLink:
      "https://docs.arcade.dev/en/resources/integrations/productivity/linear",
    relativeDocsLink: "/en/resources/integrations/productivity/linear",
    category: "productivity",
    type: "arcade",
    isComingSoon: false,
    isHidden: false,
  },
  {
    id: "Linkedin",
    label: "LinkedIn",
    isBYOC: false,
    isPro: false,
    publicIconUrl: `${PUBLIC_ICON_URL}/linkedin.svg`,
    docsLink:
      "https://docs.arcade.dev/en/resources/integrations/social-communication/linkedin",
    relativeDocsLink:
      "/en/resources/integrations/social-communication/linkedin",
    category: "social",
    type: "arcade",
    isComingSoon: false,
    isHidden: false,
  },
  {
    id: "LumaApi",
    label: "Luma API",
    isBYOC: false,
    isPro: false,
    publicIconUrl: `${PUBLIC_ICON_URL}/luma.svg`,
    docsLink:
      "https://docs.arcade.dev/en/resources/integrations/productivity/luma-api",
    relativeDocsLink: "/en/resources/integrations/productivity/luma-api",
    category: "productivity",
    type: "arcade_starter",
    isComingSoon: false,
    isHidden: false,
  },
  {
    id: "MailchimpMarketingApi",
    label: "Mailchimp API",
    isBYOC: false,
    isPro: false,
    publicIconUrl: `${PUBLIC_ICON_URL}/mailchimp.svg`,
    docsLink:
      "https://docs.arcade.dev/en/resources/integrations/productivity/mailchimp-marketing-api",
    relativeDocsLink:
      "/en/resources/integrations/productivity/mailchimp-marketing-api",
    category: "productivity",
    type: "arcade_starter",
    isComingSoon: false,
    isHidden: false,
  },
  {
    id: "Math",
    label: "Math",
    isBYOC: false,
    isPro: false,
    publicIconUrl: `${PUBLIC_ICON_URL}/math-toolkit.svg`,
    docsLink:
      "https://docs.arcade.dev/en/resources/integrations/development/math",
    relativeDocsLink: "/en/resources/integrations/development/math",
    category: "development",
    type: "arcade",
    isComingSoon: false,
    isHidden: false,
  },
  {
    id: "MicrosoftDynamics",
    label: "Microsoft Dynamics",
    isBYOC: false,
    isPro: false,
    publicIconUrl: `${PUBLIC_ICON_URL}/microsoft-dynamics.svg`,
    docsLink:
      "https://docs.arcade.dev/en/resources/integrations/productivity/microsoft_dynamics",
    relativeDocsLink:
      "/en/resources/integrations/productivity/microsoft_dynamics",
    category: "productivity",
    type: "arcade",
    isComingSoon: true,
    isHidden: false,
  },
  {
    id: "MicrosoftExcel",
    label: "Microsoft Excel",
    isBYOC: false,
    isPro: false,
    publicIconUrl: `${PUBLIC_ICON_URL}/microsoft-excel.svg`,
    docsLink:
      "https://docs.arcade.dev/en/resources/integrations/productivity/microsoft-excel",
    relativeDocsLink: "/en/resources/integrations/productivity/microsoft-excel",
    category: "productivity",
    type: "arcade",
    isComingSoon: false,
    isHidden: false,
  },
  {
    id: "MicrosoftPowerBI",
    label: "Microsoft Power BI",
    isBYOC: false,
    isPro: false,
    publicIconUrl: `${PUBLIC_ICON_URL}/microsoft-power-bi.svg`,
    docsLink:
      "https://docs.arcade.dev/en/resources/integrations/productivity/microsoft-power-bi",
    relativeDocsLink:
      "/en/resources/integrations/productivity/microsoft-power-bi",
    category: "productivity",
    type: "arcade",
    isComingSoon: false,
    isHidden: false,
  },
  {
    id: "MicrosoftPowerpoint",
    label: "Microsoft PowerPoint",
    isBYOC: false,
    isPro: false,
    publicIconUrl: `${PUBLIC_ICON_URL}/microsoft-powerpoint.svg`,
    docsLink:
      "https://docs.arcade.dev/en/resources/integrations/productivity/microsoft-powerpoint",
    relativeDocsLink:
      "/en/resources/integrations/productivity/microsoft-powerpoint",
    category: "productivity",
    type: "arcade",
    isComingSoon: false,
    isHidden: false,
  },
  {
    id: "MicrosoftSharePoint",
    label: "Microsoft SharePoint",
    isBYOC: false,
    isPro: false,
    publicIconUrl: `${PUBLIC_ICON_URL}/microsoft-sharepoint.svg`,
    docsLink:
      "https://docs.arcade.dev/en/resources/integrations/productivity/microsoft-sharepoint",
    relativeDocsLink:
      "/en/resources/integrations/productivity/microsoft-sharepoint",
    category: "productivity",
    type: "arcade",
    isComingSoon: false,
    isHidden: false,
  },
  {
    id: "Sharepoint",
    label: "Microsoft SharePoint (legacy toolkit id)",
    isBYOC: false,
    isPro: false,
    publicIconUrl: `${PUBLIC_ICON_URL}/microsoft-sharepoint.svg`,
    docsLink:
      "https://docs.arcade.dev/en/resources/integrations/productivity/sharepoint",
    relativeDocsLink: "/en/resources/integrations/productivity/sharepoint",
    category: "productivity",
    type: "arcade",
    isComingSoon: false,
    isHidden: true,
  },
  {
    id: "MicrosoftTeams",
    label: "Microsoft Teams",
    isBYOC: false,
    isPro: false,
    publicIconUrl: `${PUBLIC_ICON_URL}/microsoft-teams.svg`,
    docsLink:
      "https://docs.arcade.dev/en/resources/integrations/social-communication/microsoft-teams",
    relativeDocsLink:
      "/en/resources/integrations/social-communication/microsoft-teams",
    category: "social",
    type: "arcade",
    isComingSoon: false,
    isHidden: false,
  },
  {
    id: "MicrosoftWord",
    label: "Microsoft Word",
    isBYOC: false,
    isPro: false,
    publicIconUrl: `${PUBLIC_ICON_URL}/microsoft-word.svg`,
    docsLink:
      "https://docs.arcade.dev/en/resources/integrations/productivity/microsoft-word",
    relativeDocsLink: "/en/resources/integrations/productivity/microsoft-word",
    category: "productivity",
    type: "arcade",
    isComingSoon: false,
    isHidden: false,
  },
  {
    id: "MiroApi",
    label: "Miro API",
    isBYOC: false,
    isPro: false,
    publicIconUrl: `${PUBLIC_ICON_URL}/miro.svg`,
    docsLink:
      "https://docs.arcade.dev/en/resources/integrations/productivity/miro-api",
    relativeDocsLink: "/en/resources/integrations/productivity/miro-api",
    category: "productivity",
    type: "arcade_starter",
    isComingSoon: false,
    isHidden: false,
  },
  {
    id: "Monday",
    label: "Monday",
    isBYOC: false,
    isPro: false,
    publicIconUrl: `${PUBLIC_ICON_URL}/monday.svg`,
    docsLink:
      "https://docs.arcade.dev/en/resources/integrations/productivity/monday",
    relativeDocsLink: "/en/resources/integrations/productivity/monday",
    category: "productivity",
    type: "arcade",
    isComingSoon: true,
    isHidden: false,
  },
  {
    id: "MongoDB",
    label: "MongoDB",
    isBYOC: false,
    isPro: false,
    publicIconUrl: `${PUBLIC_ICON_URL}/mongodb.svg`,
    docsLink:
      "https://docs.arcade.dev/en/resources/integrations/databases/mongodb",
    relativeDocsLink: "/en/resources/integrations/databases/mongodb",
    category: "databases",
    type: "community",
    isComingSoon: false,
    isHidden: false,
  },
  {
    id: "Netsuite",
    label: "Netsuite",
    isBYOC: false,
    isPro: false,
    publicIconUrl: `${PUBLIC_ICON_URL}/netsuite.svg`,
    docsLink:
      "https://docs.arcade.dev/en/resources/integrations/productivity/netsuite",
    relativeDocsLink: "/en/resources/integrations/productivity/netsuite",
    category: "productivity",
    type: "arcade",
    isComingSoon: true,
    isHidden: false,
  },
  {
    id: "Notion",
    label: "Notion",
    isBYOC: false,
    isPro: false,
    publicIconUrl: `${PUBLIC_ICON_URL}/notion.svg`,
    docsLink:
      "https://docs.arcade.dev/en/resources/integrations/productivity/notion",
    relativeDocsLink: "/en/resources/integrations/productivity/notion",
    category: "productivity",
    type: "arcade",
    isComingSoon: false,
    isHidden: false,
  },
  {
    id: "NotionToolkit",
    label: "Notion",
    isBYOC: false,
    isPro: false,
    publicIconUrl: `${PUBLIC_ICON_URL}/notion.svg`,
    docsLink:
      "https://docs.arcade.dev/en/resources/integrations/productivity/notion",
    relativeDocsLink: "/en/resources/integrations/productivity/notion",
    category: "productivity",
    type: "arcade",
    isComingSoon: false,
    isHidden: true,
  },
  {
    id: "Obsidian",
    label: "Obsidian",
    isBYOC: false,
    isPro: false,
    publicIconUrl: `${PUBLIC_ICON_URL}/obsidian.svg`,
    docsLink:
      "https://docs.arcade.dev/en/resources/integrations/productivity/obsidian",
    relativeDocsLink: "/en/resources/integrations/productivity/obsidian",
    category: "productivity",
    type: "community",
    isComingSoon: false,
    isHidden: false,
  },
  {
    id: "Okta",
    label: "Okta",
    isBYOC: false,
    isPro: false,
    publicIconUrl: `${PUBLIC_ICON_URL}/okta.svg`,
    docsLink:
      "https://docs.arcade.dev/en/resources/integrations/productivity/okta",
    relativeDocsLink: "/en/resources/integrations/productivity/okta",
    category: "productivity",
    type: "arcade",
    isComingSoon: true,
    isHidden: false,
  },
  {
    id: "MicrosoftOnedrive",
    label: "Microsoft OneDrive",
    isBYOC: false,
    isPro: false,
    publicIconUrl: `${PUBLIC_ICON_URL}/microsoft-onedrive.svg`,
    docsLink:
      "https://docs.arcade.dev/en/resources/integrations/productivity/microsoft-onedrive",
    relativeDocsLink:
      "/en/resources/integrations/productivity/microsoft-onedrive",
    category: "productivity",
    type: "arcade",
    isComingSoon: false,
    isHidden: false,
  },
  {
    id: "MicrosoftOutlookCalendar",
    label: "Microsoft Outlook Calendar",
    isBYOC: false,
    isPro: false,
    publicIconUrl: `${PUBLIC_ICON_URL}/microsoft-outlook-calendar.svg`,
    docsLink:
      "https://docs.arcade.dev/en/resources/integrations/productivity/microsoft-outlook-calendar",
    relativeDocsLink:
      "/en/resources/integrations/productivity/microsoft-outlook-calendar",
    category: "productivity",
    type: "arcade",
    isComingSoon: false,
    isHidden: false,
  },
  {
    id: "MicrosoftOutlookMail",
    label: "Microsoft Outlook Mail",
    isBYOC: false,
    isPro: false,
    publicIconUrl: `${PUBLIC_ICON_URL}/microsoft-outlook-mail.svg`,
    docsLink:
      "https://docs.arcade.dev/en/resources/integrations/productivity/microsoft-outlook-mail",
    relativeDocsLink:
      "/en/resources/integrations/productivity/microsoft-outlook-mail",
    category: "productivity",
    type: "arcade",
    isComingSoon: false,
    isHidden: false,
  },
  {
    id: "OutlookCalendar",
    label: "Outlook Calendar",
    isBYOC: false,
    isPro: false,
    publicIconUrl: `${PUBLIC_ICON_URL}/microsoft-outlook-calendar.svg`,
    docsLink:
      "https://docs.arcade.dev/en/resources/integrations/productivity/outlook-calendar",
    relativeDocsLink:
      "/en/resources/integrations/productivity/outlook-calendar",
    category: "productivity",
    type: "arcade",
    isComingSoon: false,
    isHidden: true,
  },
  {
    id: "OutlookMail",
    label: "Outlook Mail",
    isBYOC: false,
    isPro: false,
    publicIconUrl: `${PUBLIC_ICON_URL}/microsoft-outlook-mail.svg`,
    docsLink:
      "https://docs.arcade.dev/en/resources/integrations/productivity/outlook-mail",
    relativeDocsLink: "/en/resources/integrations/productivity/outlook-mail",
    category: "productivity",
    type: "arcade",
    isComingSoon: false,
    isHidden: true,
  },
  {
    id: "PagerDuty",
    label: "PagerDuty",
    isBYOC: false,
    isPro: false,
    publicIconUrl: `${PUBLIC_ICON_URL}/pagerduty.svg`,
    docsLink:
      "https://docs.arcade.dev/en/resources/integrations/development/pagerduty",
    relativeDocsLink: "/en/resources/integrations/development/pagerduty",
    category: "development",
    type: "arcade",
    isComingSoon: false,
    isHidden: false,
  },
  {
    id: "PagerDutyApi",
    label: "PagerDuty API",
    isBYOC: false,
    isPro: false,
    publicIconUrl: `${PUBLIC_ICON_URL}/pagerduty.svg`,
    docsLink:
      "https://docs.arcade.dev/en/resources/integrations/development/pagerduty-api",
    relativeDocsLink: "/en/resources/integrations/development/pagerduty-api",
    category: "customer-support",
    type: "arcade_starter",
    isComingSoon: false,
    isHidden: false,
  },
  {
    id: "Pinecone",
    label: "Pinecone",
    isBYOC: false,
    isPro: false,
    publicIconUrl: `${PUBLIC_ICON_URL}/pinecone.svg`,
    docsLink:
      "https://docs.arcade.dev/en/resources/integrations/development/pinecone",
    relativeDocsLink: "/en/resources/integrations/development/pinecone",
    category: "development",
    type: "arcade",
    isComingSoon: true,
    isHidden: false,
  },
  {
    id: "Pinterest",
    label: "Pinterest",
    isBYOC: false,
    isPro: false,
    publicIconUrl: `${PUBLIC_ICON_URL}/pinterest.svg`,
    docsLink:
      "https://docs.arcade.dev/en/resources/integrations/social-communication/pinterest",
    relativeDocsLink:
      "/en/resources/integrations/social-communication/pinterest",
    category: "social",
    type: "arcade",
    isComingSoon: true,
    isHidden: false,
  },
  {
    id: "Pipedrive",
    label: "Pipedrive",
    isBYOC: false,
    isPro: false,
    publicIconUrl: `${PUBLIC_ICON_URL}/pipedrive.svg`,
    docsLink:
      "https://docs.arcade.dev/en/resources/integrations/productivity/pipedrive",
    relativeDocsLink: "/en/resources/integrations/productivity/pipedrive",
    category: "productivity",
    type: "arcade",
    isComingSoon: true,
    isHidden: false,
  },
  {
    id: "Plaid",
    label: "Plaid",
    isBYOC: false,
    isPro: false,
    publicIconUrl: `${PUBLIC_ICON_URL}/plaid.svg`,
    docsLink:
      "https://docs.arcade.dev/en/resources/integrations/productivity/plaid",
    relativeDocsLink: "/en/resources/integrations/productivity/plaid",
    category: "productivity",
    type: "arcade",
    isComingSoon: true,
    isHidden: false,
  },
  {
    id: "Posthog",
    label: "PostHog",
    isBYOC: false,
    isPro: false,
    publicIconUrl: `${PUBLIC_ICON_URL}/posthog.svg`,
    docsLink:
      "https://docs.arcade.dev/en/resources/integrations/development/posthog",
    relativeDocsLink: "/en/resources/integrations/development/posthog",
    category: "development",
    type: "arcade",
    isComingSoon: false,
    isHidden: false,
  },
  {
    id: "PosthogApi",
    label: "PostHog API",
    isBYOC: false,
    isPro: false,
    publicIconUrl: `${PUBLIC_ICON_URL}/posthog.svg`,
    docsLink:
      "https://docs.arcade.dev/en/resources/integrations/development/posthog-api",
    relativeDocsLink: "/en/resources/integrations/development/posthog-api",
    category: "development",
    type: "arcade_starter",
    isComingSoon: false,
    isHidden: false,
  },
  {
    id: "Postgres",
    label: "Postgres",
    isBYOC: false,
    isPro: false,
    publicIconUrl: `${PUBLIC_ICON_URL}/postgres.svg`,
    docsLink:
      "https://docs.arcade.dev/en/resources/integrations/databases/postgres",
    relativeDocsLink: "/en/resources/integrations/databases/postgres",
    category: "databases",
    type: "community",
    isComingSoon: false,
    isHidden: false,
  },
  {
    id: "Postman",
    label: "Postman",
    isBYOC: false,
    isPro: false,
    publicIconUrl: `${PUBLIC_ICON_URL}/postman.svg`,
    docsLink:
      "https://docs.arcade.dev/en/resources/integrations/development/postman",
    relativeDocsLink: "/en/resources/integrations/development/postman",
    category: "development",
    type: "arcade",
    isComingSoon: false,
    isHidden: false,
  },
  {
    id: "Pylon",
    label: "Pylon",
    isBYOC: false,
    isPro: false,
    publicIconUrl: `${PUBLIC_ICON_URL}/pylon.svg`,
    docsLink:
      "https://docs.arcade.dev/en/resources/integrations/customer-support/pylon",
    relativeDocsLink: "/en/resources/integrations/customer-support/pylon",
    category: "customer-support",
    type: "arcade",
    isComingSoon: false,
    isHidden: false,
  },
  {
    id: "PylonApi",
    label: "Pylon API",
    isBYOC: false,
    isPro: false,
    publicIconUrl: `${PUBLIC_ICON_URL}/pylon.svg`,
    docsLink:
      "https://docs.arcade.dev/en/resources/integrations/customer-support/pylon-api",
    relativeDocsLink: "/en/resources/integrations/customer-support/pylon-api",
    category: "customer-support",
    type: "arcade_starter",
    isComingSoon: false,
    isHidden: false,
  },
  {
    id: "Quickbooks",
    label: "QuickBooks",
    isBYOC: false,
    isPro: false,
    publicIconUrl: `${PUBLIC_ICON_URL}/quickbooks.svg`,
    docsLink:
      "https://docs.arcade.dev/en/resources/integrations/productivity/quickbooks",
    relativeDocsLink: "/en/resources/integrations/productivity/quickbooks",
    category: "productivity",
    type: "arcade",
    isComingSoon: true,
    isHidden: false,
  },
  {
    id: "Railway",
    label: "Railway",
    isBYOC: false,
    isPro: false,
    publicIconUrl: `${PUBLIC_ICON_URL}/railway.svg`,
    docsLink:
      "https://docs.arcade.dev/en/resources/integrations/development/railway",
    relativeDocsLink: "/en/resources/integrations/development/railway",
    category: "development",
    type: "arcade",
    isComingSoon: true,
    isHidden: false,
  },
  {
    id: "Reddit",
    label: "Reddit",
    isBYOC: false,
    isPro: false,
    publicIconUrl: `${PUBLIC_ICON_URL}/reddit.svg`,
    docsLink:
      "https://docs.arcade.dev/en/resources/integrations/social-communication/reddit",
    relativeDocsLink: "/en/resources/integrations/social-communication/reddit",
    category: "social",
    type: "arcade",
    isComingSoon: false,
    isHidden: false,
  },
  {
    id: "Resend",
    label: "Resend",
    isBYOC: false,
    isPro: false,
    publicIconUrl: `${PUBLIC_ICON_URL}/resend.svg`,
    docsLink:
      "https://docs.arcade.dev/en/resources/integrations/productivity/resend",
    relativeDocsLink: "/en/resources/integrations/productivity/resend",
    category: "productivity",
    type: "arcade",
    isComingSoon: false,
    isHidden: false,
  },
  {
    id: "Salesforce",
    label: "Salesforce",
    isBYOC: false,
    isPro: false,
    publicIconUrl: `${PUBLIC_ICON_URL}/salesforce.svg`,
    docsLink:
      "https://docs.arcade.dev/en/resources/integrations/sales/salesforce",
    relativeDocsLink: "/en/resources/integrations/sales/salesforce",
    category: "sales",
    type: "arcade",
    isComingSoon: false,
    isHidden: false,
  },
  {
    id: "Shopify",
    label: "Shopify",
    isBYOC: false,
    isPro: false,
    publicIconUrl: `${PUBLIC_ICON_URL}/shopify.svg`,
    docsLink:
      "https://docs.arcade.dev/en/resources/integrations/productivity/shopify",
    relativeDocsLink: "/en/resources/integrations/productivity/shopify",
    category: "productivity",
    type: "arcade",
    isComingSoon: true,
    isHidden: false,
  },
  {
    id: "Singlestore",
    label: "SingleStore",
    isBYOC: false,
    isPro: false,
    publicIconUrl: `${PUBLIC_ICON_URL}/singlestore.svg`,
    docsLink:
      "https://docs.arcade.dev/en/resources/integrations/development/singlestore",
    relativeDocsLink: "/en/resources/integrations/development/singlestore",
    category: "development",
    type: "arcade",
    isComingSoon: true,
    isHidden: false,
  },
  {
    id: "Slack",
    label: "Slack",
    isBYOC: false,
    isPro: false,
    publicIconUrl: `${PUBLIC_ICON_URL}/slack.svg`,
    docsLink:
      "https://docs.arcade.dev/en/resources/integrations/social-communication/slack",
    relativeDocsLink: "/en/resources/integrations/social-communication/slack",
    category: "social",
    type: "arcade",
    isComingSoon: false,
    isHidden: false,
  },
  {
    id: "SlackApi",
    label: "Slack API",
    isBYOC: false,
    isPro: false,
    publicIconUrl: `${PUBLIC_ICON_URL}/slack.svg`,
    docsLink:
      "https://docs.arcade.dev/en/resources/integrations/social-communication/slack-api",
    relativeDocsLink:
      "/en/resources/integrations/social-communication/slack-api",
    category: "social",
    type: "arcade_starter",
    isComingSoon: false,
    isHidden: false,
  },
  {
    id: "Snowflake",
    label: "Snowflake",
    isBYOC: false,
    isPro: false,
    publicIconUrl: `${PUBLIC_ICON_URL}/snowflake.svg`,
    docsLink:
      "https://docs.arcade.dev/en/resources/integrations/development/snowflake",
    relativeDocsLink: "/en/resources/integrations/development/snowflake",
    category: "development",
    type: "arcade",
    isComingSoon: true,
    isHidden: false,
  },
  {
    id: "Splunk",
    label: "Splunk",
    isBYOC: false,
    isPro: false,
    publicIconUrl: `${PUBLIC_ICON_URL}/splunk.svg`,
    docsLink:
      "https://docs.arcade.dev/en/resources/integrations/development/splunk",
    relativeDocsLink: "/en/resources/integrations/development/splunk",
    category: "development",
    type: "arcade",
    isComingSoon: true,
    isHidden: false,
  },
  {
    id: "Spotify",
    label: "Spotify",
    isBYOC: false,
    isPro: false,
    publicIconUrl: `${PUBLIC_ICON_URL}/spotify.svg`,
    docsLink:
      "https://docs.arcade.dev/en/resources/integrations/entertainment/spotify",
    relativeDocsLink: "/en/resources/integrations/entertainment/spotify",
    category: "entertainment",
    type: "arcade",
    isComingSoon: false,
    isHidden: false,
  },
  {
    id: "SquareUpApi",
    label: "SquareUp API",
    isBYOC: false,
    isPro: false,
    publicIconUrl: `${PUBLIC_ICON_URL}/square.svg`,
    docsLink:
      "https://docs.arcade.dev/en/resources/integrations/productivity/squareup-api",
    relativeDocsLink: "/en/resources/integrations/productivity/squareup-api",
    category: "productivity",
    type: "arcade_starter",
    isComingSoon: false,
    isHidden: false,
  },
  {
    id: "Squarespace",
    label: "Squarespace",
    isBYOC: false,
    isPro: false,
    publicIconUrl: `${PUBLIC_ICON_URL}/squarespace.svg`,
    docsLink:
      "https://docs.arcade.dev/en/resources/integrations/productivity/squarespace",
    relativeDocsLink: "/en/resources/integrations/productivity/squarespace",
    category: "productivity",
    type: "arcade",
    isComingSoon: true,
    isHidden: false,
  },
  {
    id: "Stripe",
    label: "Stripe",
    isBYOC: false,
    isPro: false,
    publicIconUrl: `${PUBLIC_ICON_URL}/stripe.svg`,
    docsLink:
      "https://docs.arcade.dev/en/resources/integrations/payments/stripe",
    relativeDocsLink: "/en/resources/integrations/payments/stripe",
    category: "payments",
    type: "arcade",
    isComingSoon: false,
    isHidden: false,
  },
  {
    id: "StripeApi",
    label: "Stripe API",
    isBYOC: false,
    isPro: false,
    publicIconUrl: `${PUBLIC_ICON_URL}/stripe.svg`,
    docsLink:
      "https://docs.arcade.dev/en/resources/integrations/payments/stripe_api",
    relativeDocsLink: "/en/resources/integrations/payments/stripe_api",
    category: "payments",
    type: "arcade_starter",
    isComingSoon: false,
    isHidden: false,
  },
  {
    id: "Telegram",
    label: "Telegram",
    isBYOC: false,
    isPro: false,
    publicIconUrl: `${PUBLIC_ICON_URL}/telegram.svg`,
    docsLink:
      "https://docs.arcade.dev/en/resources/integrations/social-communication/telegram",
    relativeDocsLink:
      "/en/resources/integrations/social-communication/telegram",
    category: "social",
    type: "arcade",
    isComingSoon: false,
    isHidden: false,
  },
  {
    id: "Tiktok",
    label: "TikTok",
    isBYOC: false,
    isPro: false,
    publicIconUrl: `${PUBLIC_ICON_URL}/tiktok.svg`,
    docsLink:
      "https://docs.arcade.dev/en/resources/integrations/social-communication/tiktok",
    relativeDocsLink: "/en/resources/integrations/social-communication/tiktok",
    category: "social",
    type: "arcade",
    isComingSoon: true,
    isHidden: false,
  },
  {
    id: "TickTickApi",
    label: "TickTick API",
    isBYOC: false,
    isPro: false,
    publicIconUrl: `${PUBLIC_ICON_URL}/ticktick.svg`,
    docsLink:
      "https://docs.arcade.dev/en/resources/integrations/productivity/ticktick-api",
    relativeDocsLink: "/en/resources/integrations/productivity/ticktick-api",
    category: "productivity",
    type: "arcade_starter",
    isComingSoon: false,
    isHidden: false,
  },
  {
    id: "TrelloApi",
    label: "Trello API",
    isBYOC: false,
    isPro: false,
    publicIconUrl: `${PUBLIC_ICON_URL}/trello.svg`,
    docsLink:
      "https://docs.arcade.dev/en/resources/integrations/productivity/trello-api",
    relativeDocsLink: "/en/resources/integrations/productivity/trello-api",
    category: "productivity",
    type: "arcade_starter",
    isComingSoon: false,
    isHidden: false,
  },
  {
    id: "Twilio",
    label: "Twilio",
    isBYOC: false,
    isPro: false,
    publicIconUrl: `${PUBLIC_ICON_URL}/twilio.svg`,
    docsLink:
      "https://docs.arcade.dev/en/resources/integrations/social-communication/twilio",
    relativeDocsLink: "/en/resources/integrations/social-communication/twilio",
    category: "social",
    type: "verified",
    isComingSoon: false,
    isHidden: false,
  },
  {
    id: "Twitch",
    label: "Twitch",
    isBYOC: false,
    isPro: false,
    publicIconUrl: `${PUBLIC_ICON_URL}/twitch.svg`,
    docsLink:
      "https://docs.arcade.dev/en/resources/integrations/entertainment/twitch",
    relativeDocsLink: "/en/resources/integrations/entertainment/twitch",
    category: "entertainment",
    type: "auth",
    isComingSoon: false,
    isHidden: false,
  },
  {
    id: "Vercel",
    label: "Vercel",
    isBYOC: false,
    isPro: false,
    publicIconUrl: `${PUBLIC_ICON_URL}/vercel.svg`,
    docsLink:
      "https://docs.arcade.dev/en/resources/integrations/development/vercel",
    relativeDocsLink: "/en/resources/integrations/development/vercel",
    category: "development",
    type: "arcade",
    isComingSoon: false,
    isHidden: false,
  },
  {
    id: "VercelApi",
    label: "Vercel API",
    isBYOC: false,
    isPro: false,
    publicIconUrl: `${PUBLIC_ICON_URL}/vercel.svg`,
    docsLink:
      "https://docs.arcade.dev/en/resources/integrations/development/vercel-api",
    relativeDocsLink: "/en/resources/integrations/development/vercel-api",
    category: "development",
    type: "arcade_starter",
    isComingSoon: false,
    isHidden: false,
  },
  {
    id: "Walmart",
    label: "Walmart",
    isBYOC: true,
    isPro: true,
    publicIconUrl: `${PUBLIC_ICON_URL}/walmart.svg`,
    docsLink:
      "https://docs.arcade.dev/en/resources/integrations/search/walmart",
    relativeDocsLink: "/en/resources/integrations/search/walmart",
    category: "search",
    type: "arcade",
    isComingSoon: false,
    isHidden: false,
  },
  {
    id: "WeaviateApi",
    label: "Weaviate API",
    isBYOC: false,
    isPro: false,
    publicIconUrl: `${PUBLIC_ICON_URL}/weaviate.svg`,
    docsLink:
      "https://docs.arcade.dev/en/resources/integrations/databases/weaviate-api",
    relativeDocsLink: "/en/resources/integrations/databases/weaviate-api",
    category: "databases",
    type: "arcade_starter",
    isComingSoon: false,
    isHidden: false,
  },
  {
    id: "Workday",
    label: "Workday",
    isBYOC: false,
    isPro: false,
    publicIconUrl: `${PUBLIC_ICON_URL}/workday.svg`,
    docsLink:
      "https://docs.arcade.dev/en/resources/integrations/productivity/workday",
    relativeDocsLink: "/en/resources/integrations/productivity/workday",
    category: "productivity",
    type: "arcade",
    isComingSoon: true,
    isHidden: false,
  },
  {
    id: "Wrike",
    label: "Wrike",
    isBYOC: false,
    isPro: false,
    publicIconUrl: `${PUBLIC_ICON_URL}/wrike.svg`,
    docsLink:
      "https://docs.arcade.dev/en/resources/integrations/productivity/wrike",
    relativeDocsLink: "/en/resources/integrations/productivity/wrike",
    category: "productivity",
    type: "arcade",
    isComingSoon: true,
    isHidden: false,
  },
  {
    id: "X",
    label: "X",
    isBYOC: false,
    isPro: false,
    publicIconUrl: `${PUBLIC_ICON_URL}/x.svg`,
    docsLink:
      "https://docs.arcade.dev/en/resources/integrations/social-communication/x",
    relativeDocsLink: "/en/resources/integrations/social-communication/x",
    category: "social",
    type: "arcade",
    isComingSoon: false,
    isHidden: false,
  },
  {
    id: "XeroApi",
    label: "Xero API",
    isBYOC: false,
    isPro: false,
    publicIconUrl: `${PUBLIC_ICON_URL}/xero.svg`,
    docsLink:
      "https://docs.arcade.dev/en/resources/integrations/productivity/xero-api",
    relativeDocsLink: "/en/resources/integrations/productivity/xero-api",
    category: "productivity",
    type: "arcade_starter",
    isComingSoon: false,
    isHidden: false,
  },
  {
    id: "YugabyteDB",
    label: "YugabyteDB",
    isBYOC: false,
    isPro: false,
    publicIconUrl: `${PUBLIC_ICON_URL}/yugabytedb.svg`,
    docsLink:
      "https://docs.arcade.dev/en/resources/integrations/databases/yugabytedb",
    relativeDocsLink: "/en/resources/integrations/databases/yugabytedb",
    category: "databases",
    type: "arcade_starter",
    isComingSoon: false,
    isHidden: false,
  },
  {
    id: "ZohoBooksApi",
    label: "Zoho Books API",
    isBYOC: false,
    isPro: false,
    publicIconUrl: `${PUBLIC_ICON_URL}/zoho-books.svg`,
    docsLink:
      "https://docs.arcade.dev/en/resources/integrations/payments/zoho-books-api",
    relativeDocsLink: "/en/resources/integrations/payments/zoho-books-api",
    category: "payments",
    type: "arcade_starter",
    isComingSoon: false,
    isHidden: false,
  },
  {
    id: "ZohoCreatorApi",
    label: "Zoho Creator API",
    isBYOC: false,
    isPro: false,
    publicIconUrl: `${PUBLIC_ICON_URL}/zoho-creator.svg`,
    docsLink:
      "https://docs.arcade.dev/en/resources/integrations/development/zoho-creator-api",
    relativeDocsLink: "/en/resources/integrations/development/zoho-creator-api",
    category: "development",
    type: "arcade_starter",
    isComingSoon: false,
    isHidden: false,
  },
  {
    id: "Youtube",
    label: "Youtube",
    isBYOC: true,
    isPro: true,
    publicIconUrl: `${PUBLIC_ICON_URL}/youtube.svg`,
    docsLink:
      "https://docs.arcade.dev/en/resources/integrations/search/youtube",
    relativeDocsLink: "/en/resources/integrations/search/youtube",
    category: "search",
    type: "arcade",
    isComingSoon: false,
    isHidden: false,
  },
  {
    id: "Zendesk",
    label: "Zendesk",
    isBYOC: false,
    isPro: false,
    publicIconUrl: `${PUBLIC_ICON_URL}/zendesk.svg`,
    docsLink:
      "https://docs.arcade.dev/en/resources/integrations/customer-support/zendesk",
    relativeDocsLink: "/en/resources/integrations/customer-support/zendesk",
    category: "customer-support",
    type: "arcade",
    isComingSoon: false,
    isHidden: false,
  },
  {
    id: "Zoom",
    label: "Zoom",
    isBYOC: false,
    isPro: false,
    publicIconUrl: `${PUBLIC_ICON_URL}/zoom.svg`,
    docsLink:
      "https://docs.arcade.dev/en/resources/integrations/social-communication/zoom",
    relativeDocsLink: "/en/resources/integrations/social-communication/zoom",
    category: "social",
    type: "arcade",
    isComingSoon: false,
    isHidden: false,
  },
];

export const TOOLKIT_CATALOGUE: Record<string, Toolkit> = TOOLKITS.reduce(
  (acc, toolkit) => {
    acc[toolkit.id] = toolkit;
    return acc;
  },
  // biome-ignore lint/plugin/no-type-assertion: existing type assertion; prefer type guards for new code
  {} as Record<string, Toolkit>
);
